/**
 * Argus Live — `/argus-live/dashboards/$id` layout route.
 *
 * This is a thin pathless LAYOUT that simply renders its matched child via
 * `<Outlet/>`. It exists so the two leaf routes that share the `$id` segment —
 *   - `/argus-live/dashboards/$id/`      → the cockpit OPERATE view (index)
 *   - `/argus-live/dashboards/$id/edit`  → the 3-pane authoring editor
 * have a common parent in the generated route tree.
 *
 * It deliberately holds NO data-loading or auth logic: each leaf route does its
 * own `read:argus_live` gate + `useArgusLiveDashboard` fetch (the operate view
 * and the editor have different layouts + permission affordances, so sharing a
 * loader here would couple them). Keeping the layout empty means the OPERATE
 * view renders full-bleed without the editor's chrome and vice-versa.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/argus-live/dashboards/$id')({
  component: ArgusLiveDashboardIdLayout,
});

function ArgusLiveDashboardIdLayout() {
  return <Outlet />;
}
